import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import './SkuModal.scss';

const SkuModal = (props) => {
  const { t } = useTranslation();
  const { onSubmit } = props;
  const [skuInput, setSkuInput] = useState("");

  const handleSubmit = () => {
    if (skuInput.trim()) {
      const skuList = skuInput
        .split("\n")
        .map((sku) => sku.trim())
        .filter((sku) => sku !== "");
      onSubmit(skuList);
      setSkuInput("");
    }
  };

  return (
    <div
      className="modal sku-modal"
      id="skuModal"
      tabIndex={-1}
      aria-labelledby="skuModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="skuModalLabel">
              {t("SKU")}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <textarea
              className="sku-modal-text"
              placeholder={t("Enter one SKU per line...")}
              value={skuInput}
              onChange={(e) => setSkuInput(e.target.value)}
            />
          </div>
          <div className="modal-footer">
            <button
              className="main-body-top-inputs-bar-col-right-submit-btn com-btn"
              data-bs-dismiss="modal"
              onClick={handleSubmit}
            >
              {t("Submit")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkuModal;
